<template>
  <div class="home-page">
    <!-- 内容区域（可滚动） -->
    <div class="content-container">
      <!-- 数据概览卡片 -->
      <div class="data-cards">
        <div class="data-card">
          <div class="card-header">
            <h3>今日收入(元)</h3>
          </div>
          <div class="card-content">
            <div class="data-value">{{statistics.order_today}}</div>
            <div class="data-change">
              <span class="icon up" v-if="statistics.order_d_value>=0">↑</span>
              <span class="icon down" v-else>↓</span>
              <span class="text">较昨日 {{statistics.order_d_value}}</span>
            </div>
          </div>
        </div>
        
        <div class="data-card">
          <div class="card-header">
            <h3>订单总金额(元)</h3>
          </div>
          <div class="card-content">
            <div class="data-value">{{statistics.order_total}}</div>
          </div>
        </div>
        
        <div class="data-card">
          <div class="card-header">
            <h3>用户注册(人)</h3>
          </div>
          <div class="card-content">
            <div class="data-value">{{statistics.user_register}}</div>
            <div class="data-change">
              <span class="icon up" v-if="statistics.today_register>=0">↑</span>
              <span class="icon down" v-else>↓</span>
              <span class="text">今日注册 {{statistics.today_register}}</span>
            </div>
          </div>
        </div>
        
        <div class="data-card">
          <div class="card-header">
            <h3>活跃用户(人)</h3>
          </div>
          <div class="card-content">
            <div class="data-value">{{statistics.user_active}}</div>
            <div class="data-change">
              <span class="icon up" v-if="statistics.active_d_value>=0">↑</span>
              <span class="icon down" v-else>↓</span>
              <span class="text">较昨日 {{statistics.active_d_value}}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 地图和日历区域 -->
      <div class="bottom-section">
        <!-- 地图分布 -->
        <div class="map-container">
          <div class="section-header">
            <h3>分布图</h3>
            <span class="update-time">2024-09-09 15:53 更新</span>
          </div>
          <div class="map-wrapper">
            <!-- 地图占位符 -->
            <map-component></map-component>
          </div>
        </div>
        
        <!-- 最新事件 -->
        <div class="calendar-container">
          <div class="section-header">
            <h3>最新事件</h3>
            <span class="more-link">查看日历</span>
          </div>
          <div class="events-wrapper">
            <!-- 当前时间日期 -->
            <div class="current-date">
              <h4>{{ currentDate }}</h4>
              <span class="weekday">{{ currentWeekday }}</span>
            </div>
            
            <!-- 特殊节日列表 -->
            <div class="festivals-section">
              <h5>未来三天节日</h5>
              <div class="festivals-list">
                <div 
                  v-for="festival in upcomingFestivals" 
                  :key="festival.date"
                  :class="['festival-item', { 'today-festival': festival.isToday }]"
                >
                  <span class="festival-date">{{ festival.date }}</span>
                  <span class="festival-name">{{ festival.name }}</span>
                </div>
                <div v-if="upcomingFestivals.length === 0" class="no-events">
                  未来三天无特殊节日
                </div>
              </div>
            </div>
            
            <!-- 今日特殊事件 -->
            <div class="today-events-section">
              <h5>今日事件</h5>
              <div v-if="todayEvents.length > 0" class="events-list">
                <div v-for="event in todayEvents" :key="event.id" class="event-item">
                  <h6 class="event-title">{{ event.title }}</h6>
                  <p class="event-content">{{ event.content }}</p>
                </div>
              </div>
              <div v-else class="no-events">
                今日无特殊事件
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 报表区域 -->
      <div class="reports-section">
        <div class="time-order-container">
          <div class="section-header">
            <h3>实时报表</h3>
          </div>
          <div class="wrapper">
            <time-order-component></time-order-component>
          </div>
        </div>
        
        <div class="order-reports-row">
          <div class="order-report-container">
            <div class="section-header">
              月度订单
            </div>
            <div class="wrapper">
              <month-order-component></month-order-component>
            </div>
          </div>
          
          <div class="order-report-container">
            <div class="section-header">
              年度报表
            </div>
            <div class="wrapper">
              <year-order-component></year-order-component>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mapComponent from "@/views/components/map.vue"
  import monthOrderComponent from "@/views/components/reports/monthOrder.vue"
  import yearOrderComponent from "@/views/components/reports/yearOrder.vue"
  import timeOrderComponent from "@/views/components/reports/timeOrder.vue"
  import newEventComponent from "@/views/components/newEvent.vue"
  import { getGroups} from "@/api/system.js";
  import {calendar} from "@/api/public.js"
  import {getOrderStatistics} from "@/api/public.js"
export default {
  name: 'HomePage',
  components:{
    mapComponent,
    monthOrderComponent,
    yearOrderComponent,
    timeOrderComponent,
    newEventComponent
  },
  data() {
    return {
      isDesktop: true,
      statistics:{
        order_today:0,
        order_total:0,
        order_d_value:0,

        user_register:0,
        today_register:0,

        user_active:0,
        active_d_value:0,

        time:'',
      },
      // 最新事件相关数据
      currentDate: '', // 当前日期，格式：YYYY-MM-DD
      currentWeekday: '', // 当前星期几
      upcomingFestivals: [], // 未来三天的节日
      todayEvents: [] // 今日事件
    }
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    this.goStatistics()
    // 初始化最新事件数据
    this.initEventsData()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods: {
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 768
    },
    goStatistics(){
      getOrderStatistics().then(res=>{
        if(res.code === 200){
          this.statistics = res.data
          this.$forceUpdate()
        }
      })
    },
    // 初始化最新事件数据
    initEventsData() {
      this.getCurrentDate()
      this.getUpcomingFestivals()
      this.getTodayEvents()
    },
    // 获取当前日期和星期
    getCurrentDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      
      this.currentDate = `${year}-${month}-${day}`
      
      // 获取星期几
      const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      this.currentWeekday = weekdays[now.getDay()]
    },
    // 获取未来三天的节日
    getUpcomingFestivals() {
      // 这里应该从API获取数据，先使用模拟数据
      const now = new Date()
      const festivals = []
      
      // 模拟未来三天的节日数据
      // 实际项目中应该从API获取
      for (let i = 0; i < 3; i++) {
        const date = new Date(now)
        date.setDate(now.getDate() + i)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const dateStr = `${year}-${month}-${day}`
        
        // 模拟节日数据
        let festivalName = ''
        if (i === 0 && month === '01' && day === '01') {
          festivalName = '元旦'
        } else if (i === 1 && month === '01' && day === '02') {
          festivalName = '元旦假期'
        }
        
        if (festivalName) {
          festivals.push({
            date: dateStr,
            name: festivalName,
            isToday: i === 0
          })
        }
      }
      
      this.upcomingFestivals = festivals
    },
    // 获取今日事件
    getTodayEvents() {
      // 这里应该从API获取数据，先使用模拟数据
      // 实际项目中应该调用this.$api.getTodayEvents()
      this.todayEvents = [
        {
          id: 1,
          title: '公司年会',
          content: '今天下午2点在公司大会议室举行年会，全体员工务必参加。'
        },
        {
          id: 2,
          title: '产品发布会',
          content: '今天晚上7点在国际会展中心举行新产品发布会，欢迎各界人士参加。'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
/* 使用全局样式中定义的 CSS 变量 */
.home-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 顶部标题（固定） */
.top-header {
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 0;
}

.top-header h2 {
  margin-bottom: 0;
  color: var(--text);
}

/* 内容区域（可滚动） */
.content-container {
  flex: 1;
  overflow-y: auto;
  padding: 10px 0;
}

/* 数据概览卡片 */
.data-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.data-card {
  background-color: var(--bg-200);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  padding: 20px;
  transition: var(--transition);
}

.data-card:hover {
  box-shadow: var(--shadow-lg);
  transform: translateY(-2px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.card-header h3 {
  margin: 0;
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text-200);
}

.update-time {
  font-size: var(--font-size-xs);
  color: var(--text-200);
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.data-value {
  font-size: 24px;
  font-weight: 600;
  color: var(--text);
}

.data-change {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: var(--font-size-xs);
}

.data-change .icon.up {
  color: var(--success);
}

.data-change .icon.down {
  color: var(--danger);
}

.data-change .text {
  color: var(--text-200);
}

/* 底部区域 */
.bottom-section {
  display: grid;
  grid-template-columns: 1fr 300px;
  gap: 20px;
}

/* 地图容器 */
.map-container {
  background-color: var(--bg-200);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  padding: 20px;
  height: 400px;
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header h3 {
  margin: 0;
  font-size: var(--font-size-md);
  font-weight: 500;
  color: var(--text);
}

.more-link {
  font-size: var(--font-size-xs);
  color: var(--primary);
  cursor: pointer;
}

.more-link:hover {
  color: var(--primary-200);
  text-decoration: underline;
}

.map-wrapper {
  flex: 1;
  position: relative;
  background-color: #1a1a1a;
  border-radius: var(--border-radius);
  overflow: hidden;
}

.map-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
}

.map-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.map-text {
  font-size: var(--font-size-sm);
}

.map-controls {
  position: absolute;
  right: 15px;
  top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.control-btn {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.8);
  color: var(--text);
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition);
}

.control-btn:hover {
  background-color: var(--bg-200);
  box-shadow: var(--shadow);
}

/* 日历/事件容器 */
.calendar-container {
  background-color: var(--bg-200);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  padding: 20px;
  height: 400px;
  display: flex;
  flex-direction: column;
}

/* 事件容器 */
.events-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow: hidden;
}

/* 当前日期 */
.current-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 5px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border);
}

.current-date h4 {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text);
}

.current-date .weekday {
  font-size: var(--font-size-xs);
  color: var(--text-200);
  margin-top: 5px;
}

/* 节日区域 */
.festivals-section {
  flex: 0 0 auto;
  max-height: 100px;
  overflow-y: auto;
}

.festivals-section h5,
.today-events-section h5 {
  margin: 0 0 8px 0;
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--text);
}

/* 节日列表 */
.festivals-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* 节日项 */
.festival-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: var(--bg);
  border-radius: var(--border-radius);
  font-size: var(--font-size-sm);
  transition: var(--transition);
}

.festival-item:hover {
  background-color: var(--light);
}

/* 今日节日 */
.today-festival {
  background-color: var(--primary-light);
  border: 1px solid var(--primary);
}

.today-festival .festival-name {
  font-weight: 600;
  color: var(--primary);
}

/* 节日日期 */
.festival-date {
  color: var(--text-200);
  font-size: var(--font-size-xs);
}

/* 节日名称 */
.festival-name {
  color: var(--text);
}

/* 今日事件区域 */
.today-events-section {
  flex: 1;
  overflow-y: auto;
}

/* 事件列表 */
.events-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 事件项 */
.event-item {
  padding: 12px;
  background-color: var(--bg);
  border-radius: var(--border-radius);
  transition: var(--transition);
}

.event-item:hover {
  background-color: var(--light);
  box-shadow: var(--shadow-sm);
}

/* 事件标题 */
.event-title {
  margin: 0 0 8px 0;
  font-size: var(--font-size-sm);
  font-weight: 600;
  color: var(--text);
}

/* 事件内容 */
.event-content {
  margin: 0;
  font-size: var(--font-size-xs);
  color: var(--text-200);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 无事件提示 */
.no-events {
  text-align: center;
  color: var(--text-200);
  font-size: var(--font-size-xs);
  padding: 20px 0;
  background-color: var(--bg);
  border-radius: var(--border-radius);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .festivals-section,
  .today-events-section {
    min-height: auto;
  }
}

/* 报表区域样式 */
.reports-section {
  margin-top: 30px;
}

/* 实时报表容器 */
.time-order-container {
  width: 100%;
  box-sizing: border-box;
  background-color: var(--bg-200);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  padding: 20px;
  height: 400px;
  margin-bottom: 20px;
}

/* 订单报表行 */
.order-reports-row {
  display: flex;
  gap: 20px;
}

/* 订单报表容器 */
.order-report-container {
  flex: 1;
  width: 50%;
  box-sizing: border-box;
  background-color: var(--bg-200);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  padding: 20px;
  height: 400px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .order-reports-row {
    flex-direction: column;
  }
  
  .time-order-container,
  .order-report-container {
    width: 100%;
  }
  .top-header {
    padding-bottom: 15px;
  }
  
  .content-container {
    padding: 15px 0;
  }
  
  .data-cards {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .bottom-section {
    grid-template-columns: 1fr;
  }
  
  .map-container,
  .calendar-container {
    height: auto;
    min-height: 300px;
  }
}
</style>